module.exports = __webpack_public_path__ + "static/media/engineer.6dcbeb4e.jpg";